<template>
  <MdButton class="md-icon-button" @click="onClick">
    <MdIcon class="fas fa-share-alt" />

    <MdDialog :md-active.sync="showDialog" :md-fullscreen="false" @md-opened="onDialogOpened">
      <MdDialogTitle>Share Showing URL</MdDialogTitle>

      <MdDialogContent>
        <div class="dialog-content">
          Copy the iGUIDE Showing URL below and share it with your clients
          <MdField>
            <MdIcon class="fas fa-copy" />
            <MdInput :value="url" ref="urlInput" @focus="onUrlFocus" readonly />
          </MdField>
        </div>
      </MdDialogContent>

      <MdDialogActions>
        <MdButton @click="showDialog = false">Close</MdButton>
      </MdDialogActions>
    </MdDialog>

    <MdSnackbar md-position="center" :md-active.sync="copySnackbar" md-persistent>
      <span>iGUIDE Showing URL copied!</span>
    </MdSnackbar>
  </MdButton>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  props: {
    url: { type: String, required: true },
    title: { type: String, required: true },
  },

  data() {
    return {
      showDialog: false,
      copySnackbar: false,
    };
  },

  methods: {
    onClick() {
      if (navigator.share) {
        navigator.share({
          title: 'iGUIDE Virtual Showing',
          text: `Join the virtual showing${this.title ? ` for ${this.title}.` : '.'}`,
          url: this.url,
        }).catch(() => {
          // User cancelled, do nothing
        });
      } else {
        this.showCopyDialog();
      }
    },

    showCopyDialog() {
      // XXX Display dialog with share URL that can be copied manually
      this.showDialog = true;
    },

    closeDialog() {
      this.showDialog = false;
    },

    onDialogOpened() {
      setTimeout(() => {
        this.$refs.urlInput.$el.focus();
      }, 700);
    },

    onUrlFocus() {
      this.$refs.urlInput.$el.select();
      this.copyUrl();
    },

    copyUrl() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.url).then(() => {
          this.copySnackbar = true;
        }, () => {
          // We don't have permissions, the user has to copy manually
        });
      }
    },
  },
};
</script>

<style>
.dialog-content {
  margin: 30px 0;
}
</style>
